/* eslint-disable no-useless-constructor */
import feathersClient, { makeServicePlugin, BaseModel } from '../../api'

class Zipcode extends BaseModel {
  constructor (data, options) {
    super(data, options)
  }

  // Required for FeathersVuex plugin to work after production transpile.
  static modelName = 'Zipcode'
  // Define default properties here
  static instanceDefaults () {
    return {
      name: '',
      extendRates: [],
      extendRateIds: [],
      product: 'Product',
      maxLaufzeit: ''
    }
  }
}
const servicePath = 'zipcodes'
const servicePlugin = makeServicePlugin({
  Model: Zipcode,
  service: feathersClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
feathersClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin
